import cookieMethod from "@global/helpers/cookieMethod";
import streamCart from "@page/common/js/liveStream/streamCart";
import superslides from "@global/vendors/jquery.superslides.min.js";
import mainBlockHeight from "@page/common/js/helper/mainBlockHeight";
import eventControl from "@page/common/js/helper/eventControl";
import modal from "bootstrap/js/dist/modal";
import Hammer from "@global/vendors/hammer.min";
import Vue from "vue";
import store from "@global/components/store/index.js";
import NewImage from "@global/components/global/image";
import AlertDialog from "@global/helpers/alertDialog";
import messageBox from "@global/helpers/messageBox";
import { createNamespacedHelpers } from "vuex";
import Collapse from "bootstrap/js/dist/collapse";
const { mapState, mapActions, mapGetters } = createNamespacedHelpers("miniCartModule");

global.$ = global.jQuery = require("jquery");

window.getCookie = cookieMethod.getCookie;
window.Vue = Vue;
window.AlertDialog = AlertDialog;
window.messageBox = messageBox;

if ($("#app-mini-cart").length > 0) {
	window.appNotificationCart = new Vue({
		el: "#app-mini-cart",
		components: { NewImage },
		store,
		computed: {
			...mapState([
				"totalCount",
				"generalCount",
				"refrigerationCount",
				"freezingCount",
				"dataIsLoad",
				"generalMarketProducts",
				"temperaturesData",
				"count",
			]),
			...mapGetters(["isOnlyOneTemp"]),
		},
		created() {
			this.getCartInfo();
		},
		methods: {
			...mapActions(["getCartInfo"]),
			customCount(count) {
				if (count < 10) {
					return "0" + count.toString();
				} else {
					return count.toString();
				}
			},
			mapCartLink(elementID) {
				if (elementID === 0) {
					return "/zh-tw/checkout?temp=0";
				} else if (elementID === 1) {
					return "/zh-tw/checkout?temp=1";
				} else {
					return "/zh-tw/checkout?temp=2";
				}
			},
		},
	});
}

(function (d, s, id) {
	var js,
		fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) return;
	js = d.createElement(s);
	js.id = id;
	js.src = "https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v2.11&appId=1413240712303469";
	fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

$("body").on("click", ".tab-action .tab-btn", function (e) {
	e.preventDefault();

	var $el = $(this),
		target_tab = $el.data("tab");
	if ($el.hasClass("active") || target_tab === undefined) return;
	$el.parents(".tab-btn-wrap").find("a").removeClass("active");
	$el.addClass("active");
	$el.parents(".tab-action").find(".tab-content").removeClass("active");
	$(target_tab).addClass("active");
});

function floatLabel(inputType) {
	$(inputType).each(function () {
		var $this = $(this);

		$this.focus(function () {
			$this.next().addClass("active");
		});

		if ($this.hasClass("error")) {
			$this.next().addClass("active");
			return;
		}

		$this.blur(function () {
			if ($this.val() === "" || $this.val() === "blank") {
				$this.next().removeClass();
			}
		});
	});
}
floatLabel(".floatLabel");

$(".open-modal").click(function (e) {
	e.preventDefault();
	var $el = $(this),
		target = $el.data("dialog");
	$(target).addClass("active");
});

$(".close-dialog").click(function (e) {
	e.preventDefault();
	var $el = $(this),
		target = $el.data("target");
	$(target).removeClass("active");
	unlockScroll();
});

$(document).ready(function () {
	var $fixedBar = $(".fixed-bar"),
		$fixWrap = $("#main-content"),
		fixedBar_pos,
		$window = $(window);

	function getPosition() {
		fixedBar_pos = $fixedBar.offset();
		return fixedBar_pos;
	}

	getPosition();

	function scrollToFix() {
		if (fixedBar_pos == undefined) {
			$window.unbind("scroll", scrollToFix);
			return;
		}
		if ($window.scrollTop() > fixedBar_pos.top - $fixedBar.height() - 50) {
			$fixedBar.addClass("fixed");
			$fixWrap.css("padding-top", $fixedBar.height());
		} else {
			$fixedBar.removeClass("fixed");
			$fixWrap.css("padding-top", "0px");
		}
	}
	$window.bind("scroll", scrollToFix);
	$window.resize(getPosition);
});

var loadingAnimate = function () {
	var pos = 0,
		times = 1,
		$icon = $(".icon-loading");

	var animateFun = function () {
		$icon.css("background-position-y", pos);
		setTimeout(function () {
			if (times > 10) {
				times = 1;
				pos = 0;
			} else {
				times++;
				pos = pos - 36;
			}
			animateFun();
		}, 80);
	};
	animateFun();
};

loadingAnimate();

$(document).ready(function () {
	var $btnTop = $(".gotop");
	const $header = $(".pc-header");
	const b = $header.height();

	$(window).scroll(function () {
		if ($(this).scrollTop() > 1000) {
			$btnTop.css({ opacity: 1, visibility: "visible" });
			$header.addClass("active");
		} else {
			$btnTop.css({ opacity: 0, visibility: "hidden" });
			$header.removeClass("active");
		}

		if ($(window).scrollTop() > b) {
			$header.addClass("active");
		} else {
			$header.removeClass("active");
		}
	});

	$btnTop.click(function (e) {
		e.preventDefault();
		$("html,body").animate({ scrollTop: 0 }, 300);
		return false;
	});
});

window.TwZipCode = (function ($, o) {
	o.run = function (el, opts) {
		$(el).twzipcode(opts);
	};
	o.destroy = function (el) {
		$(el).twzipcode("destroy");
	};
	return o;
})(jQuery, window.TwZipCode || {});

window.RegionSelect = function (options) {
	var that = this;
	var init = function (options) {
		this.$areaSelector = $(options.areaSelector);
		this.$addressWrap = $(options.addressWrap);
		this.twzipcode = options.twzipcode;
		this.area = {
			tw: `<div class="row with-small-gap">
                    <div class="col">
                        <div class="controls-float">
                            <div data-role="county" data-name="city" data-required="true" data-style="floatLabel form-control select-icon">
                                <label>縣市</label>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="controls-float">
                            <div data-role="district" data-name="district" data-required="true" data-style="floatLabel form-control select-icon">
                                <label>鄉鎮市區</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row with-small-gap">
                    <div class="col">
                        <div class="controls-float">
                            <input type="text" id="address" class="floatLabel form-control" name="address" placeholder="請輸入地址" required>
                            <label for="address"><span>地址</span></label>
                        </div>
                    </div>
                </div>`,
			cn: `
            <div class="row with-small-gap">
                <div class="col">
                    <div class="controls-float">
                        <select class="floatLabel form-control select-icon" name="province" id="select-cn-district" required></select>
                        <label>省份</label>
                    </div>
                </div>
            </div>
            <div class="row with-small-gap">
                <div class="col">
                    <div class="controls-float">
                        <input type="text" id="address" class="floatLabel form-control" name="address" placeholder="請輸入地址" required>
                        <label for="address"><span>地址</span></label>
                    </div>
                </div>
            </div>
            `,
			other: `
            <div class="row with-small-gap">
                <div class="col">
                    <div class="controls-float">
                        <input type="text" id="address" class="floatLabel form-control" name="address" placeholder="請輸入地址" required>
                        <label for="address"><span>地址</span></label>
                    </div>
                </div>
            </div>
            `,
		};
		var cn_json = [
			{ value: "安徽", name: "安徽" },
			{ value: "北京", name: "北京" },
			{ value: "福建", name: "福建" },
			{ value: "广东", name: "广东" },
			{ value: "甘肃", name: "甘肃" },
			{ value: "广西壮族自治区", name: "广西壮族自治区" },
			{ value: "贵州", name: "贵州" },
			{ value: "湖北", name: "湖北" },
			{ value: "河北", name: "河北" },
			{ value: "河南", name: "河南" },
			{ value: "海南", name: "海南" },
			{ value: "黑龙江", name: "黑龙江" },
			{ value: "湖南", name: "湖南" },
			{ value: "吉林", name: "吉林" },
			{ value: "江苏", name: "江苏" },
			{ value: "江西", name: "江西" },
			{ value: "辽宁", name: "辽宁" },
			{ value: "内蒙古自治区", name: "内蒙古自治区" },
			{ value: "宁夏回族自治区", name: "宁夏回族自治区" },
			{ value: "青海", name: "青海" },
			{ value: "四川", name: "四川" },
			{ value: "山东", name: "山东" },
			{ value: "上海", name: "上海" },
			{ value: "陕西", name: "陕西" },
			{ value: "山西", name: "山西" },
			{ value: "天津", name: "天津" },
			{ value: "新疆维吾尔自治区", name: "新疆维吾尔自治区" },
			{ value: "西藏自治区", name: "西藏自治区" },
			{ value: "云南", name: "云南" },
			{ value: "浙江", name: "浙江" },
			{ value: "重庆", name: "重庆" },
		];
		// get cn option
		this.cn_map = cn_json.map(function (elem) {
			return '<option value="' + elem.value + '">' + elem.name + "</option>";
		});
		checkRegion();
	};
	var checkRegion = function () {
		if ($.trim(that.$areaSelector.find("option:selected").val()) == "台灣及離島") {
			TwZipCode.run(that.twzipcode.el, that.twzipcode.opts);
		}
	};
	init.call(this, options);
};
RegionSelect.prototype.handleAddress = function () {
	var _this = this;
	_this.$areaSelector.change(function (e) {
		_this.$addressWrap.html("");
		TwZipCode.destroy(_this.twzipcode.el, _this.twzipcode.opts);
		switch ($.trim(e.target.value)) {
			case "台灣及離島":
				_this.$addressWrap.html($(_this.area.tw));
				TwZipCode.run(_this.twzipcode.el, _this.twzipcode.opts);
				break;
			case "中國":
				_this.$addressWrap.html($(_this.area.cn));
				$("#select-cn-district").html(_this.cn_map);
				break;
			default:
				_this.$addressWrap.html($(_this.area.other));
				break;
		}
	});
};
RegionSelect.prototype.handleReceipt = function () {
	var $hideReceipt = $(".hide-with-foreign");
	this.$areaSelector.change(function (e) {
		switch ($.trim(e.target.value)) {
			case "台灣及離島":
				$hideReceipt.removeClass("hide");
				break;
			default:
				$hideReceipt.addClass("hide");
				break;
		}
	});
};

var ShareAction = function () {
	var $btnShare = $(".btn-share-this"),
		$btnGetShortUrl = $(".btn-share-item"),
		shortUrl;

	var shareToSocial = function (social, url) {
		switch (social) {
			case "fb":
				// $el.attr('data-url', url);
				window.open(
					"https://www.facebook.com/sharer/sharer.php?u=" + url,
					"_blank",
					"toolbar=yes,location=yes,directories=no,status=no, menubar=yes,scrollbars=yes,resizable=no, copyhistory=yes,width=600,height=500"
				);
				break;
			case "line":
				window.location.href = "http://line.naver.jp/R/msg/text/?" + url;
				break;
			case "link":
				function isOS() {
					return navigator.userAgent.match(/ipad|iphone/i);
				}
				if ($("#copyTxt").length < 1) {
					$("body").append(
						'<form><textarea id="copyTxt" style="position: absolute; top:-100px; z-index:-1; border:0; padding: 0; opacity:0">' +
							url +
							"</textarea></form>"
					);
				}
				var el = document.getElementById("copyTxt");
				setTimeout(function () {
					if (isOS()) {
						const editable = el.contentEditable;
						const readOnly = el.readOnly;
						el.contentEditable = true;
						el.readOnly = false;
						const range = document.createRange();
						range.selectNodeContents(el);
						const sel = window.getSelection();
						sel.removeAllRanges();
						sel.addRange(range);
						el.setSelectionRange(0, 999999);
						el.contentEditable = editable;
						el.readOnly = readOnly;
					} else {
						$("textarea#copyTxt").select();
					}

					document.execCommand("copy");
					MessageBox.success("copied!");
				});

				// $('#copyTxt').remove();
				break;
			case "weibo":
				var image = $('meta[itemprop="image"]').attr("content");
				var title = $('meta[itemprop="name"]').attr("content");
				window.open(
					"http://service.weibo.com/share/share.php?url=" +
						url +
						"&title=" +
						title +
						"&pic=" +
						encodeURIComponent(image),
					"_blank",
					"toolbar=yes,location=yes,directories=no,status=no, menubar=yes,scrollbars=yes,resizable=no, copyhistory=yes,width=600,height=500"
				);
				break;
		}
		$("#lb-share").modal("hide");
	};

	$("body").on("click", ".btn-share-this", function (e) {
		e.preventDefault();
		var socialType = $(this).data("social");
		shareToSocial(socialType, shortUrl || window.location.href);
	});

	$("body").on("click", ".btn-share-item", function (e) {
		e.preventDefault();
		$.ajax({
			type: "POST",
			url: "//tpx.tw/api/Url/Short?oriurl=" + window.location.href,
			dataType: "json",
			xhrFields: {
				withCredentials: false,
			},
			error: function () {
				console.log("error");
			},
			success: function (res) {
				if (res.Meta.Code == 200) {
					shortUrl = res.Response.WhollyUrl;
				}
			},
		});
	});
};

new ShareAction();

window.renderPics = function (picUrl, sizeStr) {
	if (picUrl == null || picUrl.length === 0) return;

	var imgName = picUrl.substring(picUrl.lastIndexOf("/") + 1, picUrl.length - 4);
	var imgExtension = picUrl.substring(picUrl.length - 4, picUrl.length);
	var splitArr = picUrl.split("/");
	var folderName = splitArr[4];
	var pictureContainer = splitArr[3];

	if (picUrl.indexOf("gif") !== -1) {
		// gif不近縮圖
		return `https://${window.StaticImgDomain}/${pictureContainer}/${folderName}s/${imgName}${imgExtension}`;
	} else if (picUrl.indexOf(".mp4") !== -1) {
		if (picUrl.indexOf("pics") === -1 && picUrl.indexOf("pic") !== -1) {
			return picUrl.replace("pic", "pics");
		} else {
			return picUrl;
		}
	} else {
		return `https://${window.StaticImgDomain}/${pictureContainer}/${folderName}s/${imgName}${sizeStr}${imgExtension}`;
	}
};

if ($("#app-mini-cart-new").length > 0) {
	window.appNotificationCart = new Vue({
		el: "#app-mini-cart-new",
		components: { NewImage },
		store,
		computed: {
			...mapState([
				"totalCount",
				"generalCount",
				"refrigerationCount",
				"freezingCount",
				"dataIsLoad",
				"generalMarketProducts",
				"temperaturesData",
				"count",
			]),
			...mapGetters(["isOnlyOneTemp"]),
		},
		created() {
			this.getCartInfo();
		},
		methods: {
			...mapActions(["getCartInfo"]),
			customCount(count) {
				if (count < 10) {
					return "0" + count.toString();
				} else {
					return count.toString();
				}
			},
			mapCartLink(elementID) {
				if (elementID === 0) {
					return "/zh-tw/checkout?temp=0";
				} else if (elementID === 1) {
					return "/zh-tw/checkout?temp=1";
				} else {
					return "/zh-tw/checkout?temp=2";
				}
			},
		},
	});
}
